module.exports = __webpack_public_path__ + "img/icon_de_bg_bottom.d8ce8389.png";